import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@shared/providers/window.provider';
import { BehaviorSubject } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { LanguageProvider } from '../../types/i18n';

@Injectable({
  providedIn: 'root',
})
export class LanguageService implements LanguageProvider {
  private readonly key = 'lang';
  private readonly language$ = new BehaviorSubject<Nullable<TuiCountryIsoCode>>(
    null,
  );

  constructor(
    @Inject(WINDOW) private readonly window: Window,
    private readonly transloco: TranslocoService,
  ) {
    this.setDefaultState();
  }

  getLanguageObservable() {
    return this.language$.asObservable();
  }

  getLanguage(): Nullable<TuiCountryIsoCode> {
    return this.language$.getValue();
  }

  private setDefaultState() {
    const lang =
      (this.window.localStorage.getItem(this.key) as TuiCountryIsoCode) ??
      TuiCountryIsoCode.GB;
    this.transloco.setDefaultLang(lang);
    this.language$.next(lang);
  }

  setLanguage(language: TuiCountryIsoCode): void {
    this.transloco.setActiveLang(language);
    this.language$.next(language);
    this.window.localStorage.setItem(this.key, language);
  }
}
